import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { setStoreItem } from '~/utilities/Store';
import { LAST_LOADED } from '~/constants/LAST_LOADED';
import SportradarFactory from '~/components/Shared/Sportradar/SportradarFactory';
import { SPORTRADAR_NAMES } from '~/constants/SPORTRADAR';
import { tickerCallback } from '~/utilities/elements/buildSportradar';

export default component$(({ html }: { html?: string }): JSX.Element => {
  setStoreItem(LAST_LOADED, 'SportradarTicker');

  const uniqueTournamentId = html?.match(
    /data-sr-unique-tournament-id="([^"]+)"/
  )?.[1];
  const sport = html?.match(/data-sr-sport="([^"]+)"/)?.[1];

  return (
    <SportradarFactory
      name={SPORTRADAR_NAMES.TICKER}
      sportradarProps={{
        sport,
        onItemClick: tickerCallback.toString(),
        uniqueTournamentId,
      }}
      wrapperClass='bg-white w-full h-[61px] border-b border-b-lightGrey mb-10 md:mb-5 !p-0'
    />
  );
});
